module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    staticClass: "wordCloud"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e81514d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WordCloud.vue
// module id = 521
// module chunks = 0